









export default {
  inheritAttrs: false
};
